import SupplierTelecomRequests from '../../server/supplierTelecom';
import { addLoading, removeLoading } from './loading';

export const getAllSupplierTelecom = (
  limit,
  skip,
  search,
  orderBy = 'DESC',
  field = 'createdAt',
  loading = true,
) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    return await SupplierTelecomRequests.getAllSupplierTelecom(limit, skip, search, orderBy, field);
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const getSupplierTelecomOptions = (search, loading = true) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    const supplierTelecomOptions = await SupplierTelecomRequests.getSupplierTelecomOptions(search);
    return supplierTelecomOptions;
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const createSupplierTelecom = newSupplierTelecom => async (dispatch) => {
  dispatch(addLoading());
  try {
    await SupplierTelecomRequests.createSupplierTelecom(newSupplierTelecom);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateSupplierTelecom = updSupplierTelecom => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await SupplierTelecomRequests.updateSupplierTelecom(updSupplierTelecom);
  } finally {
    dispatch(removeLoading());
  }
};
